import axios, { AxiosInstance } from 'axios';

let authAxios: AxiosInstance | null = null;
const regularAxios: AxiosInstance = axios.create();

const createAuthAxios = (instance: AxiosInstance) => {
  authAxios = instance;
  return authAxios;
};

export { authAxios, regularAxios, createAuthAxios };
